import styled from 'styled-components';

export const Container = styled.div`
  display: none;
  grid-template-rows: repeat(2, 1fr);
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: 0.1rem;
  min-height: 1.6rem;

  img {
    width: 100%;
    max-height: 1.5rem;
  }

  .fake-image {
    width: 100%;
    height: auto;
    visibility: hidden;
  }

  @media (max-width: 768px) {
    display: grid;
    height: 3rem;
  }

  @media (max-width: 470px) {
    .cards-list-mobile {
      height: 2.1rem;
    }
  }
`;
